import React, {forwardRef, useImperativeHandle, useState} from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'antd';

import TaskResultList from '@/page/admin/JobsPage/TaskResultPage/TaskResultList';

const TaskResultModal = forwardRef(({modalTitle}, ref) => {
    const [visible, setVisible] = useState(false);
    const [submiting, setSubmiting] = useState(false);

    function showModal() {
        setVisible(true);
    }

    function closeModal() {
        setVisible(false);
        setSubmiting(false);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            width={1200}
            title={modalTitle}
            visible={visible}
            onCancel={closeModal}
            onOk={closeModal}
            okButtonProps={{loading: submiting}}
        >
            <TaskResultList />
        </Modal>
    );
});

TaskResultModal.displayName = 'TaskResultModal';

TaskResultModal.propTypes = {
    modalTitle: PropTypes.string,
};

export default TaskResultModal;
